import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { useCallback } from 'react';
import type { MarketLendWithdrawSource } from '@/lib/analytics/client/events';
import { useChainNavigation } from '@/hooks/useChainNavigation';
import { DIALOG_MAX_WIDTH, POSITION_MANAGER_DIALOG_OPTIONS } from '../dialogOptions';
import PositionManagerLendDialog from './PositionManagerLendDialog';
interface UseLendActionInput {
  marketId: MarketId;
  chainId: number;
  source: MarketLendWithdrawSource;
  /** Present the dialog edge-to-edge, as mobile cards do. */
  fullSize?: boolean;
}

/**
 * Opens the lend dialog for a portfolio row, switching the wallet to that row's chain first: the
 * portfolio is multi-chain. Carries no visibility gate; each entry point owns its own.
 */
export const useLendAction = t0 => {
  const $ = _c(11);
  const {
    marketId,
    chainId,
    source,
    fullSize: t1
  } = t0;
  const fullSize = t1 === undefined ? false : t1;
  const {
    toggleDialog
  } = useDialogContext();
  let t2;
  if ($[0] !== chainId) {
    t2 = {
      chainId
    };
    $[0] = chainId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    syncChainSwitch
  } = useChainNavigation(t2);
  let t3;
  if ($[2] !== chainId || $[3] !== fullSize || $[4] !== marketId || $[5] !== source || $[6] !== syncChainSwitch || $[7] !== toggleDialog) {
    t3 = () => {
      syncChainSwitch();
      toggleDialog(<PositionManagerLendDialog marketId={marketId} chainId={chainId} source={source} />, fullSize ? {
        ...POSITION_MANAGER_DIALOG_OPTIONS,
        fullSize: true
      } : {
        ...POSITION_MANAGER_DIALOG_OPTIONS,
        maxWidth: DIALOG_MAX_WIDTH
      });
    };
    $[2] = chainId;
    $[3] = fullSize;
    $[4] = marketId;
    $[5] = source;
    $[6] = syncChainSwitch;
    $[7] = toggleDialog;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onLendClick = t3;
  let t4;
  if ($[9] !== onLendClick) {
    t4 = {
      onLendClick
    };
    $[9] = onLendClick;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};